import { Image as ChakraImage } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type ImageProps = ComponentPropsWithRef<typeof ChakraImage>;

export function Image(props: ImageProps) {
  return <ChakraImage {...props} />;
}
